import { FunctionComponent, memo } from "react";

import Page from "../page";
import PageHeader from "../page-header";
import "./no-match.scss";
import { IProps } from "./no-match.types";

/**
 * Page rendered when any route is not matched
 */
const NoMatch: FunctionComponent<IProps> = () => {
    return (
        <Page className="not-found">
            <PageHeader title="Page not found" />
        </Page>
    );
};

export default memo(NoMatch);
